import * as React from "react"
import styled from "styled-components"
import H3 from "../../../atoms/typography/H3"
import Body from "../../../atoms/typography/Body"
import { theme } from "../../../theme"
import { MediaQuery } from "../../../../utils/design-helpers"

interface Props {
  title: string
  size?: string
  validity?: string
  price: string
  onClick: () => void
  selected?: boolean
  gradient?: string
  small?: boolean
}

const FlexedText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${MediaQuery.XS} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

const ContentContainer = styled.div<{ selected?: boolean; gradient: string; small: boolean }>`
  border: ${(props) => (props.selected ? `3px solid ${props.gradient}` : "3px solid transparent")};
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(119, 119, 119, 0.25);
  padding: ${(props) => (props.small ? "1rem 1.5rem" : "1.5rem 2rem")};

  cursor: pointer;

  :hover {
    filter: opacity(0.8);
    border: ${(props) => `3px solid ${props.gradient}`};
    box-shadow: 0px 0px 4px 0px rgba(119, 119, 119, 0.25);
  }
`

const SelectDataPlanButton: React.FC<Props> = ({
  title,
  size,
  validity,
  price,
  selected,
  onClick,
  gradient = "#81a6c8",
  small = false,
}) => {
  return (
    <ContentContainer selected={selected} onClick={onClick} gradient={gradient} small={small}>
      <FlexedText>
        <H3>{title}</H3>
        {size && (
          <Body>
            {size} - {validity}
          </Body>
        )}
        <H3>{price}</H3>
      </FlexedText>
    </ContentContainer>
  )
}

export default SelectDataPlanButton
